export { prepareRissXmlImages } from '../../../../functions/riss/rissXmlImages.mjs'

/** Make a report copy only. Keep original photos untouched and preserve aspect ratio. */
export async function convertReportPhotoToJpeg(bytes) {
  const bitmap = await createImageBitmap(new Blob([bytes]))
  try {
    if (!bitmap.width || !bitmap.height || bitmap.width * bitmap.height > 40_000_000) {
      throw new Error('This photo is too large to prepare safely. Use a smaller photo.')
    }
    const canvas = document.createElement('canvas')
    canvas.width = 640
    canvas.height = 480
    const context = canvas.getContext('2d')
    if (!context) throw new Error('This browser cannot prepare report photos.')
    context.fillStyle = '#ffffff'
    context.fillRect(0, 0, 640, 480)
    const scale = Math.min(640 / bitmap.width, 480 / bitmap.height)
    const width = bitmap.width * scale
    const height = bitmap.height * scale
    context.drawImage(bitmap, (640 - width) / 2, (480 - height) / 2, width, height)
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.85))
    if (!blob || blob.type !== 'image/jpeg') throw new Error('Could not encode the report photo as JPEG.')
    return new Uint8Array(await blob.arrayBuffer())
  } finally { bitmap.close() }
}
